import { OfferPromo } from "..";

export interface PromoDomain<T extends OfferPromo> {
    Detail: T;
    DomainId?: string;
    EventId?: string;
    OfferTagIds?: string[];
    PromoAssetId?: string;
    PricingPreviewHtml?: string;
    VersionIds?: string[];
    AssetIds?: string[];
    BadgeAssetId?: string;
    EventType?: string;
    FileName?: string;
    PromoIds?: string[];
    Type?: string;
    VersionNames?: string;
    Versions?: any;
    allVerisions?: any;
    VersionsCount?: number;
    VersionCodes?: string;
}